// ----------------------------------------------------------------------------

function getColumnsWidth(element: HTMLElement): any[] {
    const listWidth: any[] = [];
    const listCell = element.querySelectorAll<HTMLElement>('thead > tr:first-child > th');

    for (const elCell of listCell) {
        listWidth.push(elCell.offsetWidth);
    }

    return listWidth;
}

// ----------------------------------------------------------------------------

export default getColumnsWidth;
